export interface EncounterAuditLog {
    // Common fields
    DealingType: number;
    DealingTypeTitle?: string;
    PriceListId?: number;
    PriceListTitle?: string;
    FormNumber?: string;
    SponsorName?: string;
    Reason?: string;
    CreatedBy: number;
    CreatedByName?: string;
    CreatedDate: Date;
    FacilityId: number;
    PatientId: number;
    EncounterId: number;

    // Outpatient specific fields
    VisitDate?: Date;
    VisitDoctorId?: number;
    VisitDoctorName?: string;
    SectionId?: number;
    SectionTitle?: string;

    // Inpatient specific fields
    AdmissionDate?: Date;
    AdmissionDoctorId?: number;
    AdmissionDoctorName?: string;
    AdmissionReasonId?: number;
    AdmissionReasonTitle?: string;
}
